<template>
  <div class="div">
    <div class="div-top">
      <div>
        <!-- <span class="label">时间选项:</span>
        <el-radio-group v-model="searchData.TimeType" @change="timeTypeChange">
          <el-radio-button label="YearMonth">年月</el-radio-button>
          <el-radio-button label="Year">年份</el-radio-button>
        </el-radio-group> -->
        <div style="display: inline-block">
          <span class="label">选择年份:</span>

          <el-date-picker
            v-model="searchData.StartTimeYear"
            type="year"
            :picker-options="startYearOptions"
            placeholder="选择年份"
            value-format="yyyy"
            style="width: 150px; text-align: center"
            :clearable="false"
            @change="getDataList"
          >
          </el-date-picker>
          <span class="separator">至</span>
          <el-date-picker
            v-model="searchData.EndTimeYear"
            type="year"
            placeholder="结束年份"
            :picker-options="endYearOptions"
            value-format="yyyy"
            :clearable="false"
            @change="getDataList"
            style="width: 150px; text-align: center"
          >
          </el-date-picker>
        </div>
        <!-- <div v-if="searchData.TimeType === 'YearMonth'" style="display: inline-block">
          <span class="label">选择年月:</span>
          <el-date-picker
            v-model="searchData.searchYear"
            :picker-options="monthRangeOptions"
            type="monthrange"
            :clearable="false"
            range-separator="至"
            value-format="yyyyMM"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            @change="getDataList"
          >
          </el-date-picker>
        </div> -->
      </div>
      <div class="search-item" v-loading="buildingLoading">
        <div class="label">选择楼栋分类:</div>
        <el-checkbox-group v-model="searchData.Buildings" @change="BuildingsListChange">
          <el-checkbox
            v-for="item in BuildingsList"
            :key="item.Id"
            :label="item.Id"
            :disabled="item.disabled"
            >{{ item.Name }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
      <div class="search-item" v-loading="deviceTypeLoading">
        <div class="label">选择设备分类:</div>
        <el-checkbox-group
          v-model="searchData.DeviceTypes"
          @change="DeviceTypesListChange"
        >
          <el-checkbox
            v-for="item in DeviceTypesList"
            :key="item.Id"
            :label="item.Id"
            :disabled="item.disabled"
            >{{ item.DicName }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
    </div>
    <div class="dom-card" style="margin-top: 20px" v-loading="WaterPriceLoading">
      <div class="dom-card-title df aic jub">
        <div style="width: 50%" class="df aic jub">
          <span class="df aic">
            <img
              src="@/assets/shui.png"
              alt=""
              style="width: 20px; height: 20px; margin: 0px 10px"
            />水价格趋势</span
          >
          <span class="hint-text">单位：（元） </span>
        </div>
        <div style="width: 50%; padding-left: 20px" class="df aic jub">
          <span class="df aic"
            ><img
              src="@/assets/shui.png"
              alt=""
              style="width: 20px; height: 20px; margin: 0px 10px"
            />水用量趋势</span
          >
          <span class="hint-text">单位：（方） </span>
        </div>
      </div>
      <div class="df aic w100" style="margin-top: 20px">
        <EchartsDom
          type="line"
          :data="WaterPriceData?.tlist || []"
          width="50%"
          :thousandSeparator="true"
          labelPosition="top"
          height="200px"
          :isBarColors="true"
          :barColors="['#71AE48']"
          smooth
          :grid="{
            left: 60,
            top: 20,
            right: 40,
            bottom: 40,
          }"
        >
        </EchartsDom>
        <el-divider direction="vertical" class="divider ec"></el-divider>
        <EchartsDom
          type="bar"
          :data="WaterPriceData?.blist || []"
          :thousandSeparator="true"
          :decimalPlaces="0"
          :isBarColors="true"
          :barColors="['#71AE48']"
          width="50%"
          :grid="{
            left: 60,
            top: 20,
            right: 40,
            bottom: 40,
          }"
          height="200px"
        >
        </EchartsDom>
      </div>
    </div>
    <div class="dom-card" style="margin-top: 20px" v-loading="ElectricityPricLoading">
      <div class="dom-card-title df aic jub">
        <div style="width: 50%" class="df aic jub">
          <span class="df aic"
            ><img
              src="@/assets/dian.png"
              alt=""
              style="width: 20px; height: 20px; margin: 0px 10px"
            />电价格趋势</span
          >
          <span class="hint-text">单位：（元） </span>
        </div>
        <div style="width: 50%; padding-left: 20px" class="df aic jub">
          <span class="df aic"
            ><img
              src="@/assets/dian.png"
              alt=""
              style="width: 20px; height: 20px; margin: 0px 10px"
            />电用量趋势</span
          >
          <span class="hint-text">单位：（度） </span>
        </div>
      </div>
      <div class="df aic w100" style="margin-top: 20px">
        <EchartsDom
          type="line"
          :data="ElectricityPriceData?.tlist || []"
          width="50%"
          :thousandSeparator="true"
          labelPosition="top"
          height="200px"
          smooth
          :isBarColors="true"
          :barColors="['#4472C4']"
          :grid="{
            left: 60,
            top: 20,
            right: 40,
            bottom: 40,
          }"
        >
        </EchartsDom>
        <el-divider direction="vertical" class="divider ec"></el-divider>
        <EchartsDom
          type="bar"
          :data="ElectricityPriceData?.blist || []"
          :thousandSeparator="true"
          :decimalPlaces="0"
          width="50%"
          :isBarColors="true"
          :barColors="['#4472C4']"
          :grid="{
            left: 60,
            top: 20,
            right: 40,
            bottom: 40,
          }"
          height="200px"
        >
        </EchartsDom>
      </div>
    </div>

    <div class="dom-card" style="margin-top: 20px" v-loading="GasPriceLoading">
      <div class="dom-card-title df aic jub">
        <div style="width: 50%" class="df aic jub">
          <span class="df aic"
            ><img
              src="@/assets/qi.png"
              alt=""
              style="width: 20px; height: 20px; margin: 0px 10px"
            />气价格趋势</span
          >
          <span class="hint-text">单位：（元） </span>
        </div>
        <div style="width: 50%; padding-left: 20px" class="df aic jub">
          <span class="df aic"
            ><img
              src="@/assets/qi.png"
              alt=""
              style="width: 20px; height: 20px; margin: 0px 10px"
            />气用量趋势</span
          >
          <span class="hint-text">单位：（方） </span>
        </div>
      </div>
      <div class="df aic w100" style="margin-top: 20px">
        <EchartsDom
          type="line"
          :data="GasPriceData?.tlist || []"
          width="50%"
          :thousandSeparator="true"
          labelPosition="top"
          height="200px"
          smooth
          :isBarColors="true"
          :barColors="['#FFC000']"
          :grid="{
            left: 60,
            top: 20,
            right: 40,
            bottom: 40,
          }"
        >
        </EchartsDom>
        <el-divider direction="vertical" class="divider ec"></el-divider>
        <EchartsDom
          type="bar"
          :data="GasPriceData?.blist || []"
          :thousandSeparator="true"
          :decimalPlaces="0"
          width="50%"
          :isBarColors="true"
          :barColors="['#FFC000']"
          :grid="{
            left: 60,
            top: 20,
            right: 40,
            bottom: 40,
          }"
          height="200px"
        >
        </EchartsDom>
      </div>
    </div>
    <div class="dom-card" style="margin-top: 20px" v-loading="OilPriceLoading">
      <div class="dom-card-title df aic jub">
        <div style="width: 50%" class="df aic jub">
          <span class="df aic"
            ><img
              src="@/assets/you.png"
              alt=""
              style="width: 20px; height: 20px; margin: 0px 10px"
            />油价格趋势</span
          >
          <span class="hint-text">单位：（元） </span>
        </div>
        <div style="width: 50%; padding-left: 20px" class="df aic jub">
          <span class="df aic"
            ><img
              src="@/assets/you.png"
              alt=""
              style="width: 20px; height: 20px; margin: 0px 10px"
            />油用量趋势</span
          >
          <span class="hint-text">单位：（升） </span>
        </div>
      </div>
      <div class="df aic w100" style="margin-top: 20px; height: 100">
        <EchartsDom
          type="line"
          :data="OilPriceData?.tlist || []"
          width="50%"
          :thousandSeparator="true"
          labelPosition="top"
          height="200px"
          smooth
          :isBarColors="true"
          :barColors="['#EE6666']"
          :grid="{
            left: 60,
            top: 20,
            right: 40,
            bottom: 40,
          }"
        >
        </EchartsDom>
        <el-divider direction="vertical" class="divider ec"></el-divider>
        <EchartsDom
          type="bar"
          :data="OilPriceData?.blist || []"
          :thousandSeparator="true"
          :decimalPlaces="0"
          width="50%"
          :isBarColors="true"
          :barColors="['#EE6666']"
          :grid="{
            left: 60,
            top: 20,
            right: 40,
            bottom: 40,
          }"
          height="200px"
        >
        </EchartsDom>
      </div>
    </div>
    <div class="dom-card" style="margin-top: 20px" v-loading="HeatingPriceLoading">
      <div class="dom-card-title df aic jub">
        <div style="width: 50%" class="df aic jub">
          <span class="df aic"
            ><img
              src="@/assets/re.png"
              alt=""
              style="width: 20px; height: 20px; margin: 0px 10px"
            />供热价格趋势</span
          >
          <span class="hint-text">单位：（元） </span>
        </div>
        <div style="width: 50%; padding-left: 20px" class="df aic jub">
          <span class="df aic"
            ><img
              src="@/assets/re.png"
              alt=""
              style="width: 20px; height: 20px; margin: 0px 10px"
            />供热用量趋势</span
          >
          <span class="hint-text">单位：（方） </span>
        </div>
      </div>
      <div class="df aic w100" style="margin-top: 20px">
        <EchartsDom
          type="line"
          :data="HeatingPriceData?.tlist || []"
          width="50%"
          :thousandSeparator="true"
          labelPosition="top"
          height="200px"
          :isBarColors="true"
          :barColors="['#e98f36']"
          smooth
          :grid="{
            left: 60,
            top: 20,
            right: 40,
            bottom: 40,
          }"
        >
        </EchartsDom>
        <el-divider direction="vertical" class="divider ec"></el-divider>
        <EchartsDom
          type="bar"
          :data="HeatingPriceData?.blist || []"
          :thousandSeparator="true"
          :decimalPlaces="0"
          width="50%"
          :isBarColors="true"
          :barColors="['#e98f36']"
          :grid="{
            left: 60,
            top: 20,
            right: 40,
            bottom: 40,
          }"
          height="200px"
        >
        </EchartsDom>
      </div>
    </div>
    <div style="height: 20px"></div>
  </div>
</template>
<script>
import moment from "moment";

import EchartsDom from "@/components/EchartsDom/EchartsDom.vue";
export default {
  data() {
    return {
      searchData: {
        SortType: "Building",
        TimeType: "Year",

        StartTime: "",
        EndTime: "",
        DeviceTypes: [],
        Buildings: [],
        searchYear: [],
        StartTimeYear: "",
        EndTimeYear: "",
      },
      loading: false,
      deviceTypeLoading: false,
      buildingLoading: false,
      debouncedGetDataList: null,
      BuildingsList: [],
      DeviceTypesList: [],
      ElectricityPricLoading: false,
      ElectricityPriceData: {},
      WaterPriceLoading: false,
      WaterPriceData: {},
      GasPriceLoading: false,
      GasPriceData: {},
      OilPriceLoading: false,
      OilPriceData: {},
      HeatingPriceLoading: false,
      HeatingPriceData: {},

      monthRangePicking: { minDate: null, maxDate: null },
    };
  },
  props: {},
  components: { EchartsDom },
  methods: {
    classTypeChange() {
      if (this.searchData.classType == "bui") {
        this.searchData.Buildings = this.BuildingsList.map((item) => item.Id);
      } else if (this.searchData.classType == "dev") {
        this.searchData.DeviceTypes = this.DeviceTypesList.map((item) => item.Id);
      }
    },
    timeTypeChange() {
      if (this.searchData.TimeType === "Year") {
        if (!this.searchData.StartTimeYear || this.searchData.EndTimeYear) {
          this.searchData.StartTimeYear = moment().format("YYYY");
          this.searchData.EndTimeYear = moment().format("YYYY");
        }
      } else if (this.searchData.TimeType === "YearMonth") {
        this.searchData.searchYear = [
          moment().startOf("year").format("YYYYMM"),
          moment().endOf("year").format("YYYYMM"),
        ];
      }
      this.getDataList();
    },
    DeviceTypesListChange(a) {
      console.log(a);
      if (a.length === 1) {
        this.DeviceTypesList.find((item) => item.Id === a[0]).disabled = true;
      } else {
        this.DeviceTypesList.forEach((item) => {
          item.disabled = false;
        });
      }
      this.debouncedGetDataList();
    },
    BuildingsListChange(a) {
      console.log(a);
      if (a.length === 1) {
        this.BuildingsList.find((item) => item.Id === a[0]).disabled = true;
      } else {
        this.BuildingsList.forEach((item) => {
          item.disabled = false;
        });
      }

      this.debouncedGetDataList();
    },
    //获取楼栋列表
    async getBuildingDataList() {
      this.buildingLoading = true;
      await this.$http
        .post("/PB/PB_Project/GetProjectBuildingDataList", {})
        .then((res) => {
          this.buildingLoading = false;
          if (res.Success) {
            this.BuildingsList = res.Data || [];
            this.BuildingsList.forEach((item) => {
              this.$set(item, "disabled", false);
            });
            this.searchData.Buildings = this.BuildingsList.map((item) => item.Id);
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    async getProjectDeviceTypeList() {
      this.deviceTypeLoading = true;
      await this.$http.post("/PB/PB_Project/GetDevcieDictionaryMain", {}).then((res) => {
        this.deviceTypeLoading = false;
        if (res.Success) {
          this.DeviceTypesList = res.Data || [];
          this.DeviceTypesList.forEach((item) => {
            this.$set(item, "disabled", false);
          });
          this.searchData.DeviceTypes = this.DeviceTypesList.map((item) => item.Id);
        } else {
          this.$notify.error(res.Msg);
        }
      });
    },
    getDataList() {
      if (this.searchData.TimeType === "Year") {
        this.searchData.StartTime = this.searchData.StartTimeYear;
        this.searchData.EndTime = this.searchData.EndTimeYear;
      } else if (this.searchData.TimeType === "YearMonth") {
        this.searchData.StartTime = this.searchData.searchYear[0];
        this.searchData.EndTime = this.searchData.searchYear[1];
      }
      this.getElectricityPriceData();
      this.getWaterPriceData();
      this.getGasPriceData();
      this.getOilPriceData();
      this.getHeatingPriceData();
    },
    async getElectricityPriceData() {
      this.ElectricityPricLoading = true;
      this.$http
        .post("/PB/PB_Project/GetElectricityPriceAnalysis", {
          // SortType: this.searchData.SortType,
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.ElectricityPricLoading = false;
          if (res.Success) {
            this.ElectricityPriceData = res.Data || {};
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    async getWaterPriceData() {
      this.WaterPriceLoading = true;
      this.$http
        .post("/PB/PB_Project/GetWaterPriceAnalysis", {
          // SortType: this.searchData.SortType,
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.WaterPriceLoading = false;
          if (res.Success) {
            this.WaterPriceData = res.Data || {};
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    async getGasPriceData() {
      this.GasPriceLoading = true;
      this.$http
        .post("/PB/PB_Project/GetGasPriceAnalysis", {
          // SortType: this.searchData.SortType,
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.GasPriceLoading = false;
          if (res.Success) {
            this.GasPriceData = res.Data || {};
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    async getOilPriceData() {
      this.OilPriceLoading = true;
      this.$http
        .post("/PB/PB_Project/GetOilPriceAnalysis", {
          // SortType: this.searchData.SortType,
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.OilPriceLoading = false;
          if (res.Success) {
            this.OilPriceData = res.Data || {};
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    async getHeatingPriceData() {
      this.HeatingPriceLoading = true;
      this.$http
        .post("/PB/PB_Project/GetHeatingPriceAnalysis", {
          // SortType: this.searchData.SortType,
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.HeatingPriceLoading = false;
          if (res.Success) {
            this.HeatingPriceData = res.Data || {};
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
  },
  mounted() {},
  async created() {
    this.searchData.StartTimeYear = moment().subtract(5, "years").format("YYYY");
    this.searchData.EndTimeYear = moment().format("YYYY");
    this.searchData.searchYear = [
      moment().startOf("year").format("YYYYMM"),
      moment().endOf("year").format("YYYYMM"),
    ];
    this.loading = true;
    await this.getProjectDeviceTypeList();
    await this.getBuildingDataList();
    this.getDataList();
    this.debouncedGetDataList = this.$tools.debounce(function () {
      this.getDataList();
    }, 500);
  },
  computed: {
    monthRangeOptions() {
      return {
        onPick: ({ minDate, maxDate }) => {
          this.monthRangePicking = { minDate, maxDate };
        },
        disabledDate: (time) => {
          const { minDate, maxDate } = this.monthRangePicking || {};
          if (minDate && !maxDate) {
            // 限制最大跨度为12个月（含起始月，共12）
            const diffMonths = Math.abs(moment(time).diff(moment(minDate), "months"));
            return diffMonths > 11;
          }
          return false;
        },
      };
    },
    startYearOptions() {
      return {
        disabledDate: (time) => {
          const year = time.getFullYear();
          // 如果结束年份已选择，开始年份需在 [结束年份-10, 结束年份] 范围内
          if (this.searchData.EndTime) {
            const end = parseInt(this.searchData.EndTime);
            return year > end || year < end - 10;
          }
          return false;
        },
      };
    },
    endYearOptions() {
      return {
        disabledDate: (time) => {
          const year = time.getFullYear();
          // 如果开始年份已选择，结束年份需在 [开始年份, 开始年份+10] 范围内
          if (this.searchData.StartTime) {
            const start = parseInt(this.searchData.StartTime);
            return year < start || year > start + 10;
          }
          return false;
        },
      };
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.label {
  font-size: 14px;
  font-weight: bold;
  margin-right: 20px;
  margin-left: 10px;
  display: inline-block;
  width: 100px;
  text-align: right;
}
.search-item {
  display: flex;
  align-items: center;
  margin: 10px 0;
  .el-checkbox-group {
    flex: 1;
  }
}
.yearSelect {
  display: flex;
  align-items: center;
  justify-content: center;

  .separator {
    font-size: 12px;
    margin: 0 10px;
  }
}
.table-card {
  flex: 1;

  text-align: right;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  justify-content: right;
  font-size: 14px;
  font-weight: bold;
}
.Table-List {
  display: flex;

  gap: 15px;
  padding: 10px 0;
}
::v-deep .divider {
  height: auto;
}
.class-table {
  width: 100%;
  display: flex;
}
.class-tableItem {
  flex: 1;
  .class-tableItem-title {
    font-size: 14px;
    font-weight: bold;
    height: 40px;
    border-bottom: 1px solid #e4e7ed;
    display: flex;
    align-items: center;
    justify-content: right;
  }
  .class-tableItem-content {
    border-bottom: 1px solid #e4e7ed;
    display: flex;
    align-items: center;
    justify-content: right;
    height: 40px;
    font-size: 12px;
  }
}
.table-content {
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: right;
}
.bot1 {
  border-bottom: 1px solid #e4e7ed;
}
::v-deep .cpad .cell {
  padding: 0;
}
::v-deep .cpad .el-table__cell {
  padding: 0 !important;
}
::v-deep .table-row {
  .el-table__cell {
    border-bottom: 1px solid #9c9898;
  }
}
::v-deep .divider {
  width: 1px;
  height: 200px;
}
</style>
